import {
	AWARD_REVIEW_STATUS,
	COLUMN_HEADER_KEYS,
	PROPOSAL_REVIEW_STATUS,
	SUBAWARD_REVIEW_STATUS,
} from "globals/constants";

export const useRecordRevisionAccess = (formType, status, formAccesses, isLatestModification) => {
	formType = formType.toUpperCase();
	let hasAccess = false;

	if (formType === COLUMN_HEADER_KEYS.PROPOSAL) {
		hasAccess =
            (formAccesses.systemAdmin &&
                status !== PROPOSAL_REVIEW_STATUS.inDevelopment) ||
            (formAccesses.editor &&
                [
                	PROPOSAL_REVIEW_STATUS.underReview,
                	PROPOSAL_REVIEW_STATUS.approved,
                	PROPOSAL_REVIEW_STATUS.submittedToSponsor,
                	PROPOSAL_REVIEW_STATUS.underConsideration,
                	PROPOSAL_REVIEW_STATUS.funded,
                ].includes(status));
	} else if (formType === COLUMN_HEADER_KEYS.AWARD) {
		hasAccess =
            (formAccesses.systemAdmin &&
                ![
                	AWARD_REVIEW_STATUS.inReview,
                	AWARD_REVIEW_STATUS.setup,
                ].includes(status)) ||
            (formAccesses.editor && AWARD_REVIEW_STATUS.active === status) ||
						(formAccesses.editor && !isLatestModification &&
								(AWARD_REVIEW_STATUS.inReview === status || AWARD_REVIEW_STATUS.setup === status));
	} else if (formType === COLUMN_HEADER_KEYS.SUBAWARD) {
		hasAccess =
            (formAccesses.systemAdmin &&
                ![
                	SUBAWARD_REVIEW_STATUS.inReview,
                	SUBAWARD_REVIEW_STATUS.setup,
                ].includes(status)) ||
            (formAccesses.editor && SUBAWARD_REVIEW_STATUS.active === status) ||
            (formAccesses.editor && !isLatestModification &&
                (SUBAWARD_REVIEW_STATUS.inReview === status || SUBAWARD_REVIEW_STATUS.setup === status)
            );
	}

	return hasAccess ? true : false;
};
